// Components
import Icon from '@/components/base/Icon';
// Types
import type { CompoundBannerProps } from '@/components/base/InfoBanner/CompoundBanner';
import CompoundBanner from '@/components/base/InfoBanner/CompoundBanner';
import { classNames } from '@/utils/classNames';

type BannerTemplateProps = Pick<CompoundBannerProps, 'type'> & {
    children: React.ReactNode;
    withIcon?: boolean;
    additionalClass?: string;
};

export function BannerTemplate({ type, children, additionalClass = null, withIcon = true }: BannerTemplateProps) {
    const getIcon = () => {
        switch (type) {
            case 'error':
                return 'rejected';
            case 'lockedFeature':
                return 'crown';
            default:
                return 'disconnect';
        }
    };

    return (
        <CompoundBanner
            noBorder
            size="xxs"
            type={type}
            className={classNames("flex flex-col gap-2 sm:flex-row sm:gap-0", additionalClass)}>
            {withIcon && (
                <div
                    className={classNames(
                        'flex h-6 w-6 items-center justify-center rounded-full text-xs text-white',
                        {
                            'bg-icoRed': type === 'error',
                            'bg-icoOrange': type === 'warning',
                            'bg-icoBlue': type === 'info' || type === 'lockedFeature',
                            [additionalClass]: additionalClass
                        }
                    )}>
                    <Icon icon={getIcon()} />
                </div>
            )}
            <CompoundBanner.Content>{children}</CompoundBanner.Content>
        </CompoundBanner>
    );
}
